import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setIsBookmarkOpen } from "../../reducers/common-reducer";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { CALL_BODY_SCREEN, ENABLED } from "../../constants/Constants";
import GalleryViewTooltip from "../UI/Tooltip/GalleryViewTooltip";
import useShowGalleryViewTooltip from "../../hooks/useShowGalleryViewTooltip";

const BookmarkButton = () => {
    const dispatch = useDispatch();
    const { isBookmarkOpen, isRemoteParticipantJoined, currentCallBodyScreen, expandView } = useSelector((state) => state.commonReducer);
    const { bookmarkListArray } = useSelector((state) => state.bookmark);
    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();
    const showGalleryViewTooltip = useShowGalleryViewTooltip();
    const isBookmarkButtonVisibles = () => {
        return GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag?.SHOWMEBOOKMARK == ENABLED;
    };

    const isBookMarkButtonDisabled = useMemo(() => {
        if (!isRemoteParticipantJoined || !expandView || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN) {
            dispatch(setIsBookmarkOpen(false));
            return true;
        } else {
            return false;
        }
    }, [isRemoteParticipantJoined, expandView, currentCallBodyScreen]);

    return (
        <>
            {isBookmarkButtonVisibles() && (
                <div className='action-button bookmark-action-button' data-testid='bookmarkDiv'>
                    <div className='action-button-in custom-tooltip top-tooltip right-tooltip tooltip-auto-width m-hide'>
                        <button
                            className={clsx("call-action-btn open-sidebar-button", isBookmarkOpen && "active")}
                            data-testid='bookmarkButton'
                            onClick={() => dispatch(setIsBookmarkOpen(!isBookmarkOpen))}
                            disabled={isBookMarkButtonDisabled}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-bookmarks'></span>
                                {bookmarkListArray?.length > 0 && (
                                    <span className='count'>
                                        <span className='count-in' data-testid='bookmarkCount'>
                                            {bookmarkListArray?.length}
                                        </span>
                                    </span>
                                )}
                            </span>
                            <span className='for-text'>{localisedValues["bookmarks_title"]}</span>
                        </button>
                        {showGalleryViewTooltip && <GalleryViewTooltip localisedValues={localisedValues} />}
                    </div>
                </div>
            )}
        </>
    );
};

export default BookmarkButton;
